import {useUserSettings} from '@/composables/use-user-settings.js'
import {themes} from '@/constants/app.js'
import {computed} from 'vue'

/**
 * App theme composable
 */
export function useAppTheme() {

  //User settings
  const {theme, setTheme} = useUserSettings()

  //Computed
  const isDarkTheme = computed(() => theme.value === themes.DARK)
  const isLightTheme = computed(() => theme.value === themes.LIGHT)

  //Toggle
  const toggleTheme = () => setTheme(isDarkTheme.value ? themes.LIGHT : themes.DARK)
  const setLightTheme = () => setTheme(themes.LIGHT)
  const setDarkTheme = () => setTheme(themes.DARK)

  //Expose interface
  return {
    theme,
    isDarkTheme,
    isLightTheme,
    toggleTheme,
    setLightTheme,
    setDarkTheme,
  }
}
